import { memo } from 'react'

import TopicRefinementResponse, { TEST_ID } from './TopicRefinementResponse'
import type { Props as TopicRefinementResponseProps } from './TopicRefinementResponse'

const TopicRefinementResponseComponent = memo(TopicRefinementResponse)

export { TEST_ID, TopicRefinementResponseProps }

export default TopicRefinementResponseComponent
